import React from 'react';
import { Route, Routes as Switch } from 'react-router-dom';
import { login, dashboard, convert } from './uris';

// components:
import ProtectedRoute from 'components/protected-route';

// containers:
import Login from 'containers/login';
import Home from 'containers/home';
import Convert from 'containers/convert';

const Routes = () => {
    return (
        <Switch>
            <Route
                path={login}
                element={<Login />}
            />

            <Route element={<ProtectedRoute />}>
                <Route
                    path={dashboard}
                    element={<Home />}
                />

                <Route
                    path={convert}
                    element={<Convert />}
                />
            </Route>
        </Switch>
    );
};

export default Routes;
